/**
 * Shortcut for `String.toLowerCase()`.
 *
 * @param source input string
 * @returns lowercase output string
 */
const toLowerCase = (source: string): string => source.toLowerCase();

export default toLowerCase;
